export const AUTH = {
  SIGN_IN: 'SIGN_IN',
  SIGN_TOKEN: 'SIGN_TOKEN',
  GET_SIGN_URL: 'GET_SIGN_URL',
  REFRESH_TOKEN: 'REFRESH_TOKEN',
  SIGN_IN_SUCCESS: 'SIGN_IN_SUCCESS',
  SIGN_IN_FAIL: 'SIGN_IN_FAIL',

  SIGN_UP: 'SIGN_UP',
  SIGN_UP_SUCCESS: 'SIGN_UP_SUCCESS',
  SIGN_UP_FAIL: 'SIGN_UP_FAIL',

  PASS_RECOVERY: 'PASS_RECOVERY',
  TOKEN_REVOKE: 'TOKEN_REVOKE',
  PASS_RESET: 'PASS_RESET',
  PASS_RECOVERY_SUCCESS: 'PASS_RECOVERY_SUCCESS',
  PASS_RECOVERY_FAIL: 'PASS_RECOVERY_FAIL',

  LOG_OUT: 'LOG_OUT'
};
